import { render, staticRenderFns } from "./FACILITIES.vue?vue&type=template&id=5768fce4&"
import script from "./FACILITIES.vue?vue&type=script&lang=js&"
export * from "./FACILITIES.vue?vue&type=script&lang=js&"
import style0 from "./FACILITIES.vue?vue&type=style&index=0&id=5768fce4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports